import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
  country = environment.country;

  transform(value: any): any {
    return this.numberToFormat(value);
  }

  numberToFormat(value = 0) {
    let decimal = '';
    let strValue: any = value.toFixed(2);

    if (strValue.indexOf('.') > -1) {
      decimal = strValue.substr(strValue.indexOf('.'));
    }

    strValue = Math.floor(strValue).toString();
    let lastThree = '';
    if (strValue.length > 3) {
      lastThree = strValue.substr(strValue.length - 3);
    } else {
      lastThree = strValue;
    }

    const otherNumbers = strValue.substr(0, strValue.length - 3);
    (otherNumbers) ? lastThree = ',' + lastThree : '';

    if (this.country == 'IN') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + decimal;
    } else if (this.country == 'SA' || this.country == 'BR') {
      return otherNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + lastThree + decimal;
    }
  }

}
